'use client';

import { useState, useEffect } from 'react';

interface ScrollProgressIndicatorProps {
  color?: string;
  height?: number;
}

const ScrollProgressIndicator = ({
  color = 'bg-gradient-to-r from-primary to-secondary',
  height = 3,
}: ScrollProgressIndicatorProps) => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const calculateScrollProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      const totalScrollableHeight = documentHeight - windowHeight;
      const progress = (scrollTop / totalScrollableHeight) * 100;
      
      setScrollProgress(Math.min(progress, 100));
    };

    const handleScroll = () => {
      requestAnimationFrame(calculateScrollProgress);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    calculateScrollProgress();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div data-component-id="src/components/common/ScrollProgressIndicator.tsx:41:4" data-component-path="src/components/common/ScrollProgressIndicator.tsx" data-component-line="41" data-component-end-line="49" data-component-file="ScrollProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20top-20%20left-0%20right-0%20z-%5B999%5D%20bg-border%22%7D"
      className="fixed top-20 left-0 right-0 z-[999] bg-border"
      style={{ height: `${height}px` }}
    >
      <div data-component-id="src/components/common/ScrollProgressIndicator.tsx:45:6" data-component-path="src/components/common/ScrollProgressIndicator.tsx" data-component-line="45" data-component-end-line="48" data-component-file="ScrollProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        className={`h-full ${color} transition-all duration-150 ease-out`}
        style={{ width: `${scrollProgress}%` }}
      />
    </div>
  );
};

export default ScrollProgressIndicator;